// utils/tokenStorage.js
 
export const saveTokens = (token) => {
    sessionStorage.setItem('access_token', token.accessToken);
    sessionStorage.setItem('refresh_token', token.refreshToken);
    sessionStorage.setItem('id_token', token.idToken);
    // Store expiry time as timestamp
    const expiresAt = Date.now() + token.expiresIn * 1000;
    sessionStorage.setItem('expires_at', expiresAt.toString());
  };
   
  export const getAccessToken  = () => sessionStorage.getItem('access_token');
  export const getRefreshToken = () => sessionStorage.getItem('refresh_token');
  export const getExpiresAt    = () => parseInt(sessionStorage.getItem('expires_at') || '0');
  export const isTokenExpired  = () => Date.now() > getExpiresAt() - 30000; // 30s buffer
  export const getIdToken  = () => sessionStorage.getItem('id_token');

   
  export const clearTokens = () => {
    ['access_token', 'refresh_token', 'expires_at',
     'pkce_verifier', 'pkce_state'].forEach(k => sessionStorage.removeItem(k));
  };